import React, { Component } from 'react'
import NumberFormat from 'react-number-format'

export  default class CarCalculate extends Component {
  constructor (props) {
    super(props)
    //this.handleOnSubmitCustomer.bind(this);
    this.state = {
      lists: [],
      load_data: true,
      danger: false,
      car_id: 0,
      action: 'บันทึก',
      car: this.props.car,
      real_sell_price: 0,
      down_payment: 0,
      interest: 0,
      period: 0,
      car_net_profit: 0,
      car_sale_price: 0,
      percent_down: 0,
      yord_jud: 0,
      yord_jud_interest: 0,
      month_payment: 0,
      month_payment_vat: 0,
    }
  }

  componentDidMount () {
    this.setState({car_sale_price: this.state.car.car_sale_price})
  }

  handleOnChangeCarCalculate () {

    //var real_sell_price = this.state.real_sell_price
    var down_payment = this.state.down_payment
    var interest = this.state.interest
    var period = this.state.period
    var car_sale_price = this.state.car_sale_price

    if (down_payment === '')
      down_payment = 0

    if (interest === '')
      interest = 0

    if (period === '')
      period = 0

    if (car_sale_price !== '' && down_payment !== '') {
      var percent_down = (100.0 * down_payment) / car_sale_price
      this.setState({percent_down: percent_down})

      var yord_jud = car_sale_price - down_payment

      if (interest !== '') {

        this.setState({
          yord_jud: yord_jud,
        })

        if (period !== '') {
          var yord_jud_interest = yord_jud + ((yord_jud * interest / 100) * (period) / 12)
          var month_payment = yord_jud_interest / period

          // console.log('month_payment='+month_payment)

          if(month_payment!==Infinity){
            this.setState({
              month_payment: month_payment,
              month_payment_vat: (month_payment*1.07),
              yord_jud_interest: yord_jud_interest
            })
          }
        }

      }

    }

  }

  render () {

    return (

      <div className="card card-accent-success">
        <form action="" method="post">
          <div className="card-header">
            <strong>คำนวณค่างวดสินเชื่อรถยนต์</strong>
          </div>

          <div className="card-block">
            <div className="row pl-3">
              <div className="row p-1 col-sm-12">
                <h5>{this.state.car.car_name}</h5>
              </div>
            </div>
            <div className="row">
              <div className="row p-3">
                <div className="form-group col-sm-6">
                  <strong>ราคารถยนต์ :</strong>
                </div>
                <div className="form-group col-sm-3">
                  <input type="text"
                         ref="real_sell_price"
                         value={this.state.car_sale_price}
                         className="hidden"
                         onChange={()=>{}}
                  />
                  <NumberFormat
                    className="form-control"
                    thousandSeparator={true}
                    prefix={'฿'}
                    //placeholder="กรอกค่าโอน"
                    min={0}
                    max={1000000000}
                    step={1000}
                    size={10}
                    allowNegative={false}
                    value={this.state.car_sale_price}
                    onValueChange={(values) => {
                      const {value} = values
                      this.setState({car_sale_price: value}, () => {
                        this.handleOnChangeCarCalculate()
                      })

                    }}
                  />
                </div>

                <div className="form-group col-sm-6">
                  <strong>เงินดาวน์ :</strong>
                </div>
                <div className="form-group col-sm-3">
                  <input type="text"
                         ref="down_payment"
                         value={this.state.down_payment}
                         className="hidden"
                         onChange={()=>{}}
                  />
                  <NumberFormat
                    className="form-control"
                    thousandSeparator={true}
                    prefix={'฿'}
                    //placeholder="กรอกค่าโอน"
                    min={0}
                    max={1000000000}
                    step={1000}
                    size={10}
                    allowNegative={false}
                    onValueChange={(values) => {
                      const {value} = values
                      this.setState({down_payment: value}, () => {
                        this.handleOnChangeCarCalculate()
                      })

                    }}
                  />

                </div>

                <div className="form-group col-sm-6">
                  <strong>ดอกเบี้ย :</strong>
                </div>
                <div className="form-group col-sm-3">
                  <input type="text"
                         ref="interest"
                         value={this.state.interest}
                         className="hidden"
                         onChange={()=>{}}
                  />
                  <NumberFormat
                    className="form-control"
                    thousandSeparator={true}
                    suffix={' %'}
                    min={0}
                    max={1000000000}
                    step={1000}
                    size={10}
                    allowNegative={false}
                    onValueChange={(values) => {
                      const {value} = values
                      this.setState({interest: value}, () => {
                        this.handleOnChangeCarCalculate()
                      })

                    }}
                  />
                </div>

                <div className="form-group col-sm-6">
                  <strong>ระยะเวลาผ่อนชำระ :</strong>
                </div>
                <div className="form-group col-sm-3">
                  <input type="text"
                         ref="period"
                         value={this.state.period}
                         className="hidden"
                         onChange={()=>{}}
                  />
                  <NumberFormat
                    className="form-control"
                    thousandSeparator={true}
                    suffix={' งวด'}
                    //placeholder="กรอกค่าโอน"
                    min={0}
                    max={200}
                    step={1}
                    size={2}
                    allowNegative={false}
                    onValueChange={(values) => {
                      const {value} = values
                      this.setState({period: value}, () => {
                        this.handleOnChangeCarCalculate()
                      })

                    }}
                  />
                </div>

                <div className="col-md-12 text-center">
                  {/*<div className="card-block">
                   <button type="button" className="btn btn-success btn-sm">
                   <i className="icon-check"></i>  คำนวณ</button>
                   </div>*/}
                  <hr />
                </div>

                <div className="form-group col-sm-6">
                  <strong>% เงินดาวน์ :</strong>
                </div>
                <div className="form-group col-sm-3">
                  <NumberFormat
                    className="form-control"
                    thousandSeparator={true}
                    suffix={' %'}
                    decimalScale={2}
                    min={0}
                    max={1000000000}
                    step={1000}
                    size={10}
                    allowNegative={false}
                    value={this.state.percent_down}
                  />

                </div>

                <div className="form-group col-sm-6">
                  <strong>ยอดจัดสินเชื่อ :</strong>
                </div>
                <div className="form-group col-sm-3">
                  <NumberFormat
                    className="form-control"
                    thousandSeparator={true}
                    prefix={'฿'}
                    decimalScale={2}
                    min={0}
                    max={1000000000}
                    step={1000}
                    size={10}
                    allowNegative={false}
                    value={this.state.yord_jud}
                  />
                </div>

                <div className="form-group col-sm-6">
                  <strong>ยอดจัดสินเชื่อรวมดอกเบี้ย :</strong>
                </div>
                <div className="form-group col-sm-3">
                  <NumberFormat
                    className="form-control"
                    thousandSeparator={true}
                    prefix={'฿'}
                    decimalScale={2}
                    min={0}
                    max={1000000000}
                    step={1000}
                    size={10}
                    allowNegative={false}
                    value={this.state.yord_jud_interest}
                  />
                </div>

                <div className="form-group col-sm-6">
                  <strong>ค่างวดไม่รวมภาษี :</strong>
                </div>
                <div className="form-group col-sm-3">
                  <NumberFormat
                    className="form-control"
                    thousandSeparator={true}
                    prefix={'฿'}
                    decimalScale={2}
                    min={0}
                    max={1000000000}
                    step={1000}
                    size={10}
                    allowNegative={false}
                    value={this.state.month_payment}
                  />
                </div>

                <div className="form-group col-sm-6 text-primary">
                  <strong>ค่างวด + Vat 7% * :</strong>
                </div>
                <div className="form-group col-sm-3">
                  <NumberFormat
                    className="form-control"
                    thousandSeparator={true}
                    prefix={'฿'}
                    decimalScale={2}
                    min={0}
                    max={1000000000}
                    step={1000}
                    size={10}
                    allowNegative={false}
                    value={this.state.month_payment_vat}
                  />
                </div>

                <div className="form-group col-sm-6">
                  <strong>* ค่างวดรวมภาษีมูลค่าเพิ่ม</strong>
                </div>

              </div>
            </div>

          </div>
        </form>

      </div>
    )
  }
}